
import React from 'react';
import { Check } from 'lucide-react';

const MobileAppsBenefits = () => {
  const benefits = [
    {
      title: "Verbessertes Kundenerlebnis",
      description: "Intuitive, jederzeit verfügbare Interaktion."
    },
    {
      title: "Stärkere Kundenbindung",
      description: "Direkter Kanal zum Kunden für mehr Loyalität."
    },
    {
      title: "Höhere Conversion-Raten",
      description: "Vereinfachte User Journey für mehr Abschlüsse."
    },
    {
      title: "Gezielte Push-Benachrichtigungen",
      description: "Direkte, personalisierte Kommunikation."
    },
    {
      title: "Neue Umsatzquellen",
      description: "In-App-Käufe und Premium-Funktionen."
    },
    {
      title: "Wertvolle Nutzerdaten & Analytics",
      description: "Besseres Verständnis des Nutzerverhaltens."
    },
    {
      title: "Offline-Funktionalität",
      description: "Zugriff auf Inhalte auch ohne Internetverbindung."
    },
    {
      title: "Innovative Funktionen",
      description: "AR, Kamera, GPS und weitere Gerätefunktionen."
    },
    {
      title: "Schnellere Prozesse",
      description: "Optimierte Workflows für mobile Anwendungsfälle."
    },
    {
      title: "Stärkere Markenwahrnehmung",
      description: "Präsenz auf dem Startbildschirm der Nutzer."
    }
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            10 Geschäftsvorteile mobiler Apps
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Entdecken Sie, wie mobile Anwendungen Ihr Unternehmen voranbringen können
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start bg-white p-5 rounded-lg border border-gray-100 hover:shadow-md transition-all duration-300">
              <div className="rounded-full bg-green-100 p-1 mr-3 flex-shrink-0">
                <Check className="h-5 w-5 text-green-600" />
              </div>
              <div>
                <h3 className="font-bold mb-1">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileAppsBenefits;
